<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
};
</script>
<style lang="scss">
@import "@/style/variables.scss";
body{
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #323334;
}
ul,dl,ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
#app {
  .container {
    width: 1200px;
    margin: 0 auto;
  }
}
.transport-logistics{
  .nav{
    height: 40px;
    background-color: #D3D8E4;
    overflow: hidden;
    text-align: center;
    >*{
      display: inline-block;
      margin: 0;
      vertical-align: middle;
    }
    h2{
      font-size: 18px;
      color: #102565;
      margin-right: 10px;
    }
    h3{
      font-size: 16px;
      line-height: 16px;
      color: #102565;
      padding-left: 10px;
      border-left: #3C4254 solid 1px;
      margin-right: 40px;
    }
    ul{
      height: 40px;
      li{
        display: inline-block;
        line-height: 40px;
        margin-left: 28px;
        cursor: pointer;
        color: #3C4254;
        &.active{
          color: $primary;
          font-weight: bold;
        }
      }
    }
  }
  >div{
    .banner{
      height: 300px;
      background-color: #2A457A;
      >div{
        margin: 0 auto;
        height: 300px;
        background: url('@/assets/images/transport/logistics/banner.jpg') no-repeat center center;
        overflow: hidden;
        .el-form{
          width: 750px;
          margin: 130px auto 0 auto;
        }
      }
    }
    
    .result{
      background-color: #F0F2F5;
      padding: 20px 0 40px 0;
      .container{
        overflow: hidden;
        .result-item{
          background-color: #fff;
          padding: 0 14px;
          margin-top: 20px;
          border: #E4E4E4 solid 1px;
          position: relative;
          >h4{
            height: 44px;
            color: #102565;
            line-height: 44px;
            padding-left: 20px;
            font-size: 16px;
            margin: 0;
            background: url('~@/assets/images/transport/logistics/title_back.png') no-repeat left center;
          }
          >.export{
            position: absolute;
            right: 14px;
            top: 0;
            z-index: 2;
            color: #102565;
            font-size: 14px;
            height: 44px;
            line-height: 44px;
            cursor: pointer;
            background: url('~@/assets/images/transport/logistics/export.png') no-repeat left center;
            background-size: 16px 16px;
            padding-left: 20px;
          }
          >.tip{
            position: absolute;
            right: 80px;
            top: 0;
            z-index: 2;
            color: #eb5165;
            font-size: 14px;
            height: 44px;
            line-height: 44px;
            &.r{
              right: 14px;
            }
          }
          .el-table{
            .el-table__header-wrapper{
              th{
                background-color: #EEF0F6;
                font-weight: bold;
                color: #585858;
              }
            }
          }
        }
      }
      .el-loading-spinner{
        top: 10%;
      }
    }
  }
}
.el-select-dropdown{
  &.el-popper{
    &.popper-center{
      text-align: center;
      .el-select-dropdown__item{
        padding-right: 35px;
      }
    }
  }
}
</style>
